// src/enums/checkout-line-item-kind.enum.ts
var CheckoutLineItemKind = /* @__PURE__ */ ((CheckoutLineItemKind2) => {
  CheckoutLineItemKind2["OFFER"] = "offer";
  CheckoutLineItemKind2["CONSULTATION"] = "consultation";
  CheckoutLineItemKind2["CUSTOM"] = "custom";
  CheckoutLineItemKind2["DISCOUNT"] = "discount";
  return CheckoutLineItemKind2;
})(CheckoutLineItemKind || {});

// src/enums/confirmation-code-type.enum.ts
var ConfirmationCodeType = /* @__PURE__ */ ((ConfirmationCodeType2) => {
  ConfirmationCodeType2["PASSWORD_RESET"] = "password_reset";
  ConfirmationCodeType2["EMAIL_VERIFICATION"] = "email_verification";
  return ConfirmationCodeType2;
})(ConfirmationCodeType || {});

// src/enums/consultation-status.enum.ts
var ConsultationStatus = /* @__PURE__ */ ((ConsultationStatus2) => {
  ConsultationStatus2["DRAFT"] = "draft";
  ConsultationStatus2["SCHEDULED"] = "scheduled";
  ConsultationStatus2["RESCHEDULED"] = "rescheduled";
  ConsultationStatus2["COMPLETED"] = "completed";
  ConsultationStatus2["MISSED"] = "missed";
  ConsultationStatus2["CANCELLED"] = "cancelled";
  return ConsultationStatus2;
})(ConsultationStatus || {});

// src/enums/consultation-type.enum.ts
var ConsultationType = /* @__PURE__ */ ((ConsultationType2) => {
  ConsultationType2["MEDICAL"] = "medical";
  ConsultationType2["PSYCHOLOGICAL"] = "psychological";
  ConsultationType2["INFORMATIONAL"] = "informational";
  return ConsultationType2;
})(ConsultationType || {});

// src/enums/document-generation-status.enum.ts
var DocumentGenerationStatus = /* @__PURE__ */ ((DocumentGenerationStatus2) => {
  DocumentGenerationStatus2["PENDING"] = "pending";
  DocumentGenerationStatus2["PROCESSING"] = "processing";
  DocumentGenerationStatus2["READY"] = "ready";
  DocumentGenerationStatus2["FAILED"] = "failed";
  return DocumentGenerationStatus2;
})(DocumentGenerationStatus || {});

// src/enums/document-template-type.enum.ts
var DocumentTemplateType = {
  /**
   * Agreement between a patient and a medical facility.
   */
  PATIENT_FACILITY_AGREEMENT: "patient_facility_agreement"
};
var DOCUMENT_TEMPLATE_TYPE_VALUES = Object.values(DocumentTemplateType);

// src/enums/document-type.enum.ts
var DocumentType = {
  ...DocumentTemplateType,
  /**
   * Agreement between a patient and Polonia Medica.
   * Created from uploaded PDF in document settings (not from template).
   */
  PATIENT_PM_AGREEMENT: "patient_pm_agreement"
};
var DOCUMENT_TYPE_VALUES = Object.values(DocumentType);

// src/enums/gender.enum.ts
var Gender = /* @__PURE__ */ ((Gender2) => {
  Gender2["MALE"] = "male";
  Gender2["FEMALE"] = "female";
  Gender2["OTHER"] = "other";
  Gender2["PREFER_NOT_TO_SAY"] = "prefer_not_to_say";
  return Gender2;
})(Gender || {});

// src/enums/listing-filter-key.enum.ts
var ListingFilterKey = /* @__PURE__ */ ((ListingFilterKey2) => {
  ListingFilterKey2["SERVICE_CATEGORY"] = "service-category";
  ListingFilterKey2["PLACE_CATEGORY"] = "place-category";
  ListingFilterKey2["PLACE_CITY"] = "place-city";
  ListingFilterKey2["PLACE_PROVINCE"] = "place-province";
  return ListingFilterKey2;
})(ListingFilterKey || {});

// src/enums/listing-filter-type.enum.ts
var ListingFilterType = /* @__PURE__ */ ((ListingFilterType2) => {
  ListingFilterType2["CHECKBOX"] = "checkbox";
  ListingFilterType2["RADIO"] = "radio";
  return ListingFilterType2;
})(ListingFilterType || {});

// src/enums/listing-sort-order.enum.ts
var ListingSortOrder = /* @__PURE__ */ ((ListingSortOrder2) => {
  ListingSortOrder2["DEFAULT"] = "default";
  ListingSortOrder2["NEWEST"] = "newest";
  ListingSortOrder2["OLDEST"] = "oldest";
  ListingSortOrder2["NAME_ASC"] = "nameAsc";
  ListingSortOrder2["NAME_DESC"] = "nameDesc";
  ListingSortOrder2["RANDOM"] = "random";
  return ListingSortOrder2;
})(ListingSortOrder || {});

// src/enums/offer-group-status.enum.ts
var OfferGroupStatus = /* @__PURE__ */ ((OfferGroupStatus2) => {
  OfferGroupStatus2["DRAFT"] = "draft";
  OfferGroupStatus2["PENDING"] = "pending";
  OfferGroupStatus2["ACCEPTED"] = "accepted";
  OfferGroupStatus2["REJECTED"] = "rejected";
  OfferGroupStatus2["EXPIRED"] = "expired";
  OfferGroupStatus2["CANCELLED"] = "cancelled";
  return OfferGroupStatus2;
})(OfferGroupStatus || {});

// src/enums/order-checkout-status.enum.ts
var OrderCheckoutStatus = /* @__PURE__ */ ((OrderCheckoutStatus2) => {
  OrderCheckoutStatus2["AWAITING_PAYMENT"] = "awaiting_payment";
  OrderCheckoutStatus2["PARTIALLY_PAID"] = "partially_paid";
  OrderCheckoutStatus2["PAID"] = "paid";
  OrderCheckoutStatus2["OVERPAID"] = "overpaid";
  OrderCheckoutStatus2["CANCELLED"] = "cancelled";
  return OrderCheckoutStatus2;
})(OrderCheckoutStatus || {});

// src/enums/order-status.enum.ts
var OrderStatus = /* @__PURE__ */ ((OrderStatus2) => {
  OrderStatus2["ORDER_CREATED"] = "order_created";
  OrderStatus2["ORDER_COMPLETED"] = "order_completed";
  OrderStatus2["PAYMENT_PENDING"] = "payment_pending";
  OrderStatus2["PAYMENT_CONFIRMED"] = "payment_confirmed";
  OrderStatus2["PAYMENT_FAILED"] = "payment_failed";
  OrderStatus2["PAYMENT_CANCELLED"] = "payment_cancelled";
  OrderStatus2["PAYMENT_REFUNDED"] = "payment_refunded";
  OrderStatus2["PAYMENT_REFUND_FAILED"] = "payment_refund_failed";
  OrderStatus2["PAYMENT_REFUND_REQUESTED"] = "payment_refund_requested";
  OrderStatus2["PAYMENT_REFUND_REQUEST_FAILED"] = "payment_refund_request_failed";
  OrderStatus2["PAYMENT_REFUND_REQUEST_SUCCEEDED"] = "payment_refund_request_succeeded";
  OrderStatus2["OFFER_IN_PREPARATION"] = "offer_in_preparation";
  OrderStatus2["OFFER_CREATED"] = "offer_created";
  OrderStatus2["OFFER_ACCEPTED"] = "offer_accepted";
  OrderStatus2["OFFER_REJECTED"] = "offer_rejected";
  OrderStatus2["OFFER_EXPIRED"] = "offer_expired";
  OrderStatus2["OFFER_CANCELLED"] = "offer_cancelled";
  OrderStatus2["CONSULTATION_IN_PREPARATION"] = "consultation_in_preparation";
  OrderStatus2["CONSULTATION_CREATED"] = "consultation_created";
  OrderStatus2["CONSULTATION_ACCEPTED"] = "consultation_accepted";
  OrderStatus2["CONSULTATION_REJECTED"] = "consultation_rejected";
  OrderStatus2["CONSULTATION_EXPIRED"] = "consultation_expired";
  OrderStatus2["CONSULTATION_CANCELLED"] = "consultation_cancelled";
  OrderStatus2["CONSULTATION_MISSED"] = "consultation_missed";
  OrderStatus2["CONSULTATION_RESCHEDULED"] = "consultation_rescheduled";
  OrderStatus2["CONSULTATION_REFUNDED"] = "consultation_refunded";
  OrderStatus2["CONSULTATION_SCHEDULED"] = "consultation_scheduled";
  OrderStatus2["CONSULTATION_COMPLETED"] = "consultation_completed";
  OrderStatus2["TRAVEL_FORM_IN_PREPARATION"] = "travel_form_in_preparation";
  OrderStatus2["TRAVEL_FORM_SENT"] = "travel_form_sent";
  OrderStatus2["TRAVEL_FORM_COMPLETED"] = "travel_form_completed";
  OrderStatus2["TRAVEL_FORM_EXPIRED"] = "travel_form_expired";
  OrderStatus2["TRAVEL_FORM_CANCELLED"] = "travel_form_cancelled";
  return OrderStatus2;
})(OrderStatus || {});

// src/enums/order-travel-form-status.enum.ts
var OrderTravelFormStatus = /* @__PURE__ */ ((OrderTravelFormStatus2) => {
  OrderTravelFormStatus2["DRAFT"] = "draft";
  OrderTravelFormStatus2["SENT"] = "sent";
  OrderTravelFormStatus2["COMPLETED"] = "completed";
  OrderTravelFormStatus2["EXPIRED"] = "expired";
  OrderTravelFormStatus2["CANCELLED"] = "cancelled";
  return OrderTravelFormStatus2;
})(OrderTravelFormStatus || {});

// src/enums/password-setup-mode.enum.ts
var PasswordSetupMode = /* @__PURE__ */ ((PasswordSetupMode2) => {
  PasswordSetupMode2["SET_VIA_LINK"] = "set_via_link";
  PasswordSetupMode2["TEMPORARY_PASSWORD"] = "temporary_password";
  return PasswordSetupMode2;
})(PasswordSetupMode || {});

// src/enums/payment-method.enum.ts
var PaymentMethod = /* @__PURE__ */ ((PaymentMethod2) => {
  PaymentMethod2["ONLINE"] = "online";
  PaymentMethod2["STRIPE"] = "stripe";
  PaymentMethod2["BANK_TRANSFER"] = "bank_transfer";
  return PaymentMethod2;
})(PaymentMethod || {});

// src/enums/payment-purpose.enum.ts
var PaymentPurpose = /* @__PURE__ */ ((PaymentPurpose2) => {
  PaymentPurpose2["CONSULTATION"] = "consultation";
  PaymentPurpose2["OFFER"] = "offer";
  PaymentPurpose2["ORDER_CHECKOUT"] = "order_checkout";
  return PaymentPurpose2;
})(PaymentPurpose || {});

// src/enums/payment-refund-state.enum.ts
var PaymentRefundState = /* @__PURE__ */ ((PaymentRefundState2) => {
  PaymentRefundState2["NONE"] = "none";
  PaymentRefundState2["PARTIAL"] = "partial";
  PaymentRefundState2["FULL"] = "full";
  return PaymentRefundState2;
})(PaymentRefundState || {});

// src/enums/payment-status.enum.ts
var PaymentStatus = /* @__PURE__ */ ((PaymentStatus2) => {
  PaymentStatus2["REQUIRES_PAYMENT_METHOD"] = "requires_payment_method";
  PaymentStatus2["REQUIRES_CONFIRMATION"] = "requires_confirmation";
  PaymentStatus2["REQUIRES_ACTION"] = "requires_action";
  PaymentStatus2["PROCESSING"] = "processing";
  PaymentStatus2["REQUIRES_CAPTURE"] = "requires_capture";
  PaymentStatus2["SUCCEEDED"] = "succeeded";
  PaymentStatus2["CANCELED"] = "canceled";
  PaymentStatus2["FAILED"] = "failed";
  return PaymentStatus2;
})(PaymentStatus || {});

// src/enums/place-type.enum.ts
var PlaceType = /* @__PURE__ */ ((PlaceType2) => {
  PlaceType2["CLINIC"] = "CLINIC";
  PlaceType2["SANATORIUM"] = "SANATORIUM";
  PlaceType2["SPA_WELLNESS"] = "SPA_WELLNESS";
  PlaceType2["ADDICTION_TREATMENT_CENTER"] = "ADDICTION_TREATMENT_CENTER";
  return PlaceType2;
})(PlaceType || {});

// src/enums/schema-org-business-type.enum.ts
var SchemaOrgBusinessType = /* @__PURE__ */ ((SchemaOrgBusinessType2) => {
  SchemaOrgBusinessType2["LOCAL_BUSINESS"] = "LocalBusiness";
  SchemaOrgBusinessType2["DENTIST"] = "Dentist";
  SchemaOrgBusinessType2["EMERGENCY_SERVICE"] = "EmergencyService";
  SchemaOrgBusinessType2["HEALTH_AND_BEAUTY_BUSINESS"] = "HealthAndBeautyBusiness";
  SchemaOrgBusinessType2["LODGING_BUSINESS"] = "LodgingBusiness";
  SchemaOrgBusinessType2["MEDICAL_BUSINESS"] = "MedicalBusiness";
  SchemaOrgBusinessType2["SPORTS_ACTIVITY_LOCATION"] = "SportsActivityLocation";
  SchemaOrgBusinessType2["TOURIST_INFORMATION_CENTER"] = "TouristInformationCenter";
  SchemaOrgBusinessType2["TRAVEL_AGENCY"] = "TravelAgency";
  return SchemaOrgBusinessType2;
})(SchemaOrgBusinessType || {});

// src/enums/status.enum.ts
var Status = /* @__PURE__ */ ((Status2) => {
  Status2["PUBLISHED"] = "published";
  Status2["DRAFT"] = "draft";
  Status2["ARCHIVED"] = "archived";
  return Status2;
})(Status || {});

// src/enums/toast-type.enum.ts
var ToastType = /* @__PURE__ */ ((ToastType2) => {
  ToastType2["SUCCESS"] = "success";
  ToastType2["ERROR"] = "error";
  ToastType2["WARNING"] = "warning";
  ToastType2["INFO"] = "info";
  return ToastType2;
})(ToastType || {});

// src/enums/uploaded-file-type.enum.ts
var UploadedFileType = /* @__PURE__ */ ((UploadedFileType2) => {
  UploadedFileType2["PLACE_COVER"] = "place-cover";
  UploadedFileType2["PLACE_IMAGE"] = "place-image";
  UploadedFileType2["PLACE_VIDEO"] = "place-video";
  UploadedFileType2["SERVICE_COVER"] = "service-cover";
  UploadedFileType2["OFFER_GENERATED_DOCUMENT"] = "offer-generated-document";
  UploadedFileType2["OTHER"] = "other";
  return UploadedFileType2;
})(UploadedFileType || {});

// src/enums/user-creation-method.enum.ts
var UserCreationMethod = /* @__PURE__ */ ((UserCreationMethod2) => {
  UserCreationMethod2["Self"] = "self";
  UserCreationMethod2["Admin"] = "admin";
  return UserCreationMethod2;
})(UserCreationMethod || {});

// src/enums/user-role.enum.ts
var UserRole = /* @__PURE__ */ ((UserRole2) => {
  UserRole2["SUPER_ADMIN"] = "super_admin";
  UserRole2["ADMIN"] = "admin";
  UserRole2["PATIENT"] = "patient";
  UserRole2["PARTNER"] = "partner";
  UserRole2["COMMISSION_AGENT"] = "commission_agent";
  return UserRole2;
})(UserRole || {});

// src/enums/video-provider.enum.ts
var VideoProvider = /* @__PURE__ */ ((VideoProvider2) => {
  VideoProvider2["LOCAL"] = "local";
  VideoProvider2["YOUTUBE"] = "youtube";
  VideoProvider2["VIMEO"] = "vimeo";
  return VideoProvider2;
})(VideoProvider || {});

// src/utils/resolve-payment-refund-state.ts
var PAYMENT_REFUND_DISPLAY_TOLERANCE = 0.01;
function resolvePaymentRefundState(amount, refundedAmount, tolerance = PAYMENT_REFUND_DISPLAY_TOLERANCE) {
  const amt = Math.max(0, Number(amount));
  const refRaw = Math.max(0, Number(refundedAmount ?? 0));
  const ref = Math.min(refRaw, amt);
  if (ref <= tolerance) {
    return "none" /* NONE */;
  }
  if (amt <= tolerance) {
    return "partial" /* PARTIAL */;
  }
  if (amt - ref <= tolerance) {
    return "full" /* FULL */;
  }
  return "partial" /* PARTIAL */;
}
function resolveCheckoutRefundStateFromPayments(payments, tolerance = PAYMENT_REFUND_DISPLAY_TOLERANCE) {
  const relevant = payments.filter((p) => p.status === "succeeded" /* SUCCEEDED */ && Number(p.amount) > tolerance);
  if (relevant.length === 0) {
    return "none" /* NONE */;
  }
  const states = relevant.map((p) => resolvePaymentRefundState(Number(p.amount), p.refundedAmount, tolerance));
  if (states.every((s) => s === "none" /* NONE */)) {
    return "none" /* NONE */;
  }
  if (states.every((s) => s === "full" /* FULL */)) {
    return "full" /* FULL */;
  }
  return "partial" /* PARTIAL */;
}

// src/types/language.ts
import { LANGUAGE_CODES } from "@polonia-medica/data";
export {
  CheckoutLineItemKind,
  ConfirmationCodeType,
  ConsultationStatus,
  ConsultationType,
  DOCUMENT_TEMPLATE_TYPE_VALUES,
  DOCUMENT_TYPE_VALUES,
  DocumentGenerationStatus,
  DocumentTemplateType,
  DocumentType,
  Gender,
  LANGUAGE_CODES as LANGUAGES,
  ListingFilterKey,
  ListingFilterType,
  ListingSortOrder,
  DocumentGenerationStatus as OfferGeneratedDocumentStatus,
  OfferGroupStatus,
  OrderCheckoutStatus,
  OrderStatus,
  OrderTravelFormStatus,
  PAYMENT_REFUND_DISPLAY_TOLERANCE,
  PasswordSetupMode,
  PaymentMethod,
  PaymentPurpose,
  PaymentRefundState,
  PaymentStatus,
  PlaceType,
  SchemaOrgBusinessType,
  Status,
  ToastType,
  UploadedFileType,
  UserCreationMethod,
  UserRole,
  VideoProvider,
  resolveCheckoutRefundStateFromPayments,
  resolvePaymentRefundState
};
